import { actionCreatorFactory, Action } from 'typescript-fsa'

const actionCreator = actionCreatorFactory('Analytics')

type LogScreenViewPayload = {
    screen: string
}
export type LogScreenViewAction = Action<LogScreenViewPayload>
export const logScreenView = actionCreator<LogScreenViewPayload>('LOG_SCREEN_VIEW')
